<script>
  import MqModal from "./MqModal";

  export default {
    props: {
      feature_list: {
        type: Object,
        required: true
      },
      car_name: {
        type: String,
        required: true
      }
    },
    
    components: {
      MqModal
    },

    methods: {
      cancel () {
        this.$emit('close')
      }
    }
  }
  // :title="$t('account_details.modal.license_info.title')"
</script>


<template>
  <mq-modal :title="$t('cars.all_features_of', {car: car_name})">
    <div class='row'>
      <div class='column'>
        <article v-for="(value, name, index) in feature_list" :key="index" class="feature-category">
          <strong>{{ name }}</strong>
          <ul>
            <li v-for="(feature, index) in value" :key="index"> {{ feature.name }} </li>
          </ul>
        </article>
      </div>
    </div>
  </mq-modal>
</template>


// WEBPACK FOOTER //
// src/components/ModalCarFeaturesList.vue